module.exports = global.config = {
    server_url : "https://ecom-be-sudoshop.onrender.com"
    // server_url : 'http://localhost:7979'

} 
// https://sudoshopbackend.herokuapp.com/